<template>
    <!-- Add Question Modal -->
    <div class="modal fade" id="questionModal" tabindex="-1" aria-labelledby="questionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable popOutModal modal-xl">
            <div class="modal-content" ref="questionEditorModal">
                <div class="modal-header text-white">
                    <h1 class="modal-title fs-5 text-capitalize" id="questionModalLabel">{{ editorMode }} Question</h1>
                    <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>

                <div class="modal-body">

	                <div class="d-flex gap-1">
		                <button class="btn btn-sm" :class="{'btn-outline-dark' : tab !== 'current', 'btn-dark' : tab === 'current', }" @click="tab = 'current'">Current Medication</button>
		                <button class="btn btn-sm" :class="{'btn-outline-dark' : tab !== 'past', 'btn-dark' : tab === 'past', }" @click="tab = 'past'">Medication I've Taken</button>
	                </div>

                    <!-- Description Current -->
                    <div class="mb-2" v-show="tab === 'current'">
                        <p>Question Description</p>
                        <QuillEditor
                            placeholder="Please enter question details. Use keywords like [medication], [condition], [therapy], [side_effect] for dynamic selection."
                            :options="quillOptions" theme="snow" ref="questionEditor" @update:content="onUpdateContent" />
                    </div>
                    <hr v-show="tab === 'current'" />

	                <!-- Sub Text Current -->
	                <div class="mb-2" v-show="tab === 'current'">
		                <p>Sub Text (Optional)</p>
		                <textarea class="form-control" rows="2" v-model="sub_text" placeholder="Please type extra info for the question"></textarea>
	                </div>
	                <hr v-show="tab === 'current'" />

	                <!-- Description Past -->
	                <div class="mb-2" v-show="tab === 'past'">
		                <p>Question Description</p>
		                <QuillEditor
			                placeholder="Please enter question details. Use keywords like [medication], [condition], [therapy], [side_effect] for dynamic selection."
			                :options="quillOptions" theme="snow" ref="questionEditorPast" @update:content="onUpdateContentPast" />
	                </div>
	                <hr v-show="tab === 'past'" />

	                <!-- Sub Text Past -->
	                <div class="mb-2" v-show="tab === 'past'">
		                <p>Sub Text (Optional)</p>
		                <textarea class="form-control" rows="2" v-model="sub_text_past" placeholder="Please type extra info for the question"></textarea>
	                </div>
	                <hr v-show="tab === 'past'" />

                    <!-- Question Type -->
                    <div class="mb-2">
                        <p>Question Type</p>
                        <select class="form-select" v-model="question_type">
                            <option disabled selected>Select Question Type</option>
                            <option v-for="question in question_type_options" :value="question.value">{{ question.label }}</option>
                        </select>

                        <!-- Optional number of choice input -->
                        <input v-if="question_type === 'DropdownSelect' && mode === 'multiple'" id="num_choices" class="form-control mt-2" type="number"
                            min="2" max="10" v-model="num_choices"
                            placeholder="Number of answers/choices that user can select.">


	                    <ul class="list-group text-start" v-if="question_type === 'DropdownSelect' || question_type === 'LikertScale'">
		                    <li v-if="question_type === 'LikertScale'" class="cursor-pointer d-flex align-items-center list-group-item fs-6 border-0 p-0">
			                    <input class="form-check-input mt-0" type="radio" id="rating" name="mode"
			                           v-model="mode" value="rating">
			                    <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="rating">
				                    Rating
			                    </label>
		                    </li>
		                    <li v-if="question_type === 'LikertScale'" class="cursor-pointer d-flex align-items-center list-group-item fs-6 border-0 p-0">
			                    <input class="form-check-input mt-0" type="radio" id="severity" name="mode"
			                           v-model="mode" value="severity">
			                    <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="severity">
				                    Severity
			                    </label>
		                    </li>
		                    <li v-if="question_type === 'DropdownSelect'" class="cursor-pointer d-flex align-items-center list-group-item fs-6 border-0 p-0">
			                    <input class="form-check-input mt-0" type="radio" id="singular" name="mode"
			                           v-model="mode" value="singular">
			                    <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="singular">
				                    Rating
			                    </label>
		                    </li>
		                    <li v-if="question_type === 'DropdownSelect'" class="cursor-pointer d-flex align-items-center list-group-item fs-6 border-0 p-0">
			                    <input class="form-check-input mt-0" type="radio" id="multiple" name="mode"
			                           v-model="mode" value="multiple">
			                    <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="multiple">
				                    Severity
			                    </label>
		                    </li>
	                    </ul>

                    </div>
                    <hr />

                    <!-- Exclude option -->
                    <div class="mb-2" v-if="isModelQuestion">
                        <div class="d-flex justify-content-between mb-3 align-items-center">
                            <p class="m-0 w-100">Exclude Already Selected Values from Options </p>
                            <div class="custom-switch">
                                <input type="checkbox" class="switch-input" id="exclude_values"
                                    v-model="exclude_values" />
                                <label class="switch-label" for="exclude_values">
                                    <div class="ball"></div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr v-if="isModelQuestion" />

	                <!-- Min and Max Value -->
	                <div class="mb-2" v-if="question_type === 'SliderInput' || question_type === 'LikertScale'">
		                <p></p>
		                <div class="row g-2">
			                <div class="col-6">
				                <label for="minVal" class="form-label">Min Value</label>
				                <input type="text" class="form-control" id="minVal" placeholder="Min Value" v-model="min_value">
			                </div>
			                <div class="col-6">
				                <label for="maxVal" class="form-label">Max Value</label>
				                <input type="text" class="form-control" id="maxVal" placeholder="Max Value" v-model="max_value">
			                </div>
		                </div>
	                </div>
	                <hr v-if="question_type === 'SliderInput' || question_type === 'LikertScale'" />

	                <!-- Icon Name -->
	                <div class="mb-2" v-if="question_type === 'DropdownSelect' || question_type === 'BoxChoices'">
		                <p>Icon (Optional)</p>
		                <input id="icon_class" class="form-control mt-2" type="text" v-model="icon_class"
		                       placeholder="Type icon class name (e.g., bi-activity, bi-heart-pulse) to use [only bootstrap icon allowed]">
	                </div>
	                <hr v-if="question_type === 'DropdownSelect' || question_type === 'BoxChoices'" />

	                <!-- Units to Use -->
	                <div class="mb-2" v-if="question_type === 'SliderInput'">
		                <p>Unit (Optional)</p>
		                <input id="units" class="form-control mt-2" type="text" v-model="units"
		                       placeholder="Type comma separated units to use [e.g., kg, gm, lb, oz]">
	                </div>
	                <hr v-if="question_type === 'SliderInput'" />

                    <!-- Choices container -->
                    <div class="mb-2" v-if="question_type !== 'LikertScale' && question_type !== 'SliderInput'">
                        <div class="d-flex justify-content-between mb-3 align-items-center">
                            <p class="m-0">Choices</p>
                            <button type="button" class="btn btn-dark btn-sm"
                                @click="choices.push({ uuid: uuidv4(), text: '', value: '', order: choices.length + 1, type: null })">
                                Add
                            </button>
                        </div>
                        <div class="alert alert-secondary" role="alert" v-if="choices.length === 0">
                            No choices added
                        </div>
                        <div v-if="choices.length" class="d-flex justify-content-between align-items-center mb-2 gap-2">
                            <span class="me-4 fw-medium text-dark">Text</span>
                            <span class="fw-medium text-dark">Value</span>
                            <span class="fw-medium text-dark">Order</span>
                            <span class="fw-medium text-dark">Action</span>
                        </div>
                        <QuestionChoice v-for="choice in choices" :key="choice.uuid" :uuid="choice.uuid"
                            :max_order="choices.length" :question_type="question_type" :choice="choice"
                            @choice-field-updated="$event => updateChoiceData($event)"
                            @remove-choice="$event => removeChoice($event)" />
                    </div>
                    <hr v-if="question_type !== 'LikertScale' && question_type !== 'SliderInput'" />

                    <!-- Related questions container -->
                    <div class="mb-2">
                        <div class="d-flex justify-content-between mb-3 align-items-center">
                            <p class="m-0 w-100">Related Questions</p>
                            <span class="me-1">{{ question_condition ? 'ALL' : 'ANY' }}</span>
                            <div class="custom-switch me-3">
                                <input type="checkbox" class="switch-input" id="related-condition"
                                    v-model="question_condition" />
                                <label class="switch-label" for="related-condition">
                                    <span>||</span>
                                    <span>&&</span>
                                    <div class="ball"></div>
                                </label>
                            </div>
                            <button type="button" class="btn btn-dark btn-sm"
                                @click="selectedRelatedQuestions.push({ uuid: uuidv4() })">
                                Add
                            </button>
                        </div>

                        <div class="alert alert-secondary" role="alert"
                            v-if="!selectedRelatedQuestions || selectedRelatedQuestions.length === 0">
                            No questions added
                        </div>
                        <RelatedQuestion v-for="qs in selectedRelatedQuestions" :key="qs.uuid" :uuid="qs.uuid"
                            :question="qs"
                            :selected_choices="qs && qs.correct_choices && qs.correct_choices.length ? qs.correct_choices.map(choice => choice.id) : []"
                            :related_questions="relatedQuestions.filter(relatedQs => !selectedRelatedQuestions.some(selectedQs => selectedQs.id === relatedQs.id) || relatedQs.id === qs.id)"
                            @related-question-selected="$event => selectRelated($event)"
                            @selected-choices-updated="$event => relatedChoices($event)"
                            @remove-related="$event => removeRelated($event)" />
                    </div>
                    <hr />

                    <!-- Skippable -->
                    <div class="mb-2">
                        <div class="d-flex justify-content-between mb-3 align-items-center">
                            <p class="m-0 w-100">Question can be skipped?</p>
                            <div class="custom-switch">
                                <input type="checkbox" class="switch-input" id="skippable" v-model="skippable" />
                                <label class="switch-label" for="skippable">
                                    <div class="ball"></div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr />

                    <!-- Status -->
                    <div class="mb-2" v-if="variable_name !== 'medication' && variable_name !== 'condition_therapy'">
                        <div class="d-flex justify-content-between mb-3 align-items-center">
                            <p class="m-0 w-100">Status</p>
                            <span class="me-1">{{ status ? 'Active' : 'Inactive' }}</span>
                            <div class="custom-switch">
                                <input type="checkbox" class="switch-input" id="question_status" v-model="status" />
                                <label class="switch-label" for="question_status">
                                    <i class="bi bi-check"></i>
                                    <i class="bi bi-x"></i>
                                    <div class="ball"></div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr v-if="variable_name !== 'medication' && variable_name !== 'condition_therapy'" />

	                <!-- Anonymous -->
	                <div class="mb-2" v-if="variable_name !== 'medication' && variable_name !== 'condition_therapy'">
		                <div class="d-flex justify-content-between mb-3 align-items-center">
			                <p class="m-0 w-100">Use in Anonymous Survey</p>
			                <span class="me-1">{{ anonymous ? 'Yes' : 'No' }}</span>
			                <div class="custom-switch">
				                <input type="checkbox" class="switch-input" id="question_anonymous" v-model="anonymous" />
				                <label class="switch-label" for="question_anonymous">
					                <i class="bi bi-check"></i>
					                <i class="bi bi-x"></i>
					                <div class="ball"></div>
				                </label>
			                </div>
		                </div>
	                </div>
	                <hr v-if="variable_name !== 'medication' && variable_name !== 'condition_therapy'" />

                    <!-- Variable name -->
                    <div class="mb-2">
                        <p>Variable Name to Store Answer</p>
                        <select class="form-select" v-model="variable_name">
                            <option disabled selected>Please select frontend variable name to store answer or leave it
                                as it is</option>
                            <option v-for="variableNameOption in variable_name_options"
                                :value="variableNameOption.value">{{ variableNameOption.label }}</option>
                        </select>
                    </div>
                    <hr />

                    <!-- Custom variable name -->
                    <div class="mb-2">
                        <p>Custom Variable Name</p>
                        <input type="text" class="form-control"
                            placeholder="Custom Variable Name (no spaces and must begin with alphabet)"
                            v-model="custom_variable">
                    </div>
                    <hr />

                </div>
                <div style="" class="modal-footer p-2">
                    <button type="button" data-bs-dismiss="modal" class="btn btn-sm btn-outline-dark">Close</button>
                    <button type="button" data-bs-dismiss="modal" class="btn btn-sm btn-dark" v-ripple
                        @click="saveQuestion">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch, nextTick } from "vue";
import Modal from "bootstrap/js/dist/modal";
import { question_type_options, variable_name_options, validVariables } from '@/utils/questionVariables.js';
import QuestionChoice from "./QuestionChoice.vue";
import RelatedQuestion from "./RelatedQuestion.vue";
import { v4 as uuidv4 } from "uuid";
import apiClient from "@/utils/axios";
import { useHttpErrorManager } from '@/composables/useHttpErrorManager';
import { useAppHelpers } from '@/composables/useAppHelpers';
import { useToast } from "@/composables/useToast.js";

const props = defineProps({
    id: Number
});
const emits = defineEmits(['questionAdded', 'questionEdited', 'closeModal']);
const helper = useAppHelpers();
const toast = useToast()

const editorMode = ref(props.id ? 'edit' : 'add');
const questionEditor = ref(null);
const questionEditorPast = ref(null);
const quillOptions = ref(
    {
        modules:
        {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                ['clean'],
                ['link']
            ],
            syntax:
            {
                highlight: text => hljs.highlightAuto(text).value
            }
        },
        theme: 'snow'
    }
);

const question = ref(null);
const relatedQuestions = ref([]);
const tab = ref('current');

const description = ref("");
const description_past = ref("");
const sub_text = ref(null);
const sub_text_past = ref(null);
const question_type = ref(null);
const num_choices = ref(2);
const mode = ref(null);
const min_value = ref(null);
const max_value = ref(null);
const exclude_values = ref(false);
const icon_class = ref(null);
const units = ref(null);
const choices = ref([]);
const question_condition = ref(false);
const selectedRelatedQuestions = ref([]);
const skippable = ref(false);
const status = ref(false);
const anonymous = ref(false);
const variable_name = ref(null);
const custom_variable = ref(null);

const questionEditorModal = ref(null);
const modal = ref(null);

const isModelQuestion = computed(() => {
	let models = ['Medication', 'Condition', 'Therapy', 'SideEffect', 'Symptom', 'Condition,Therapy', 'Country'];
	if (choices.value.length === 0) {
		return false;
	}
	let modelMatched = false;
	for (let i = 0; i < choices.value.length; i++) {
		const trimmedText = choices.value[i].value?.trim();
		if (trimmedText && models.includes(trimmedText)) {
			modelMatched = true;
			break;
		}
	}
	return question_type.value === 'DropdownSelect' && modelMatched;

});

// const onEditorReady = (editorInstance) => {
// 	if (!questionEditor.value) {
// 		questionEditor.value = editorInstance
// 	}
// 	if (props.id) {
// 		nextTick(() => {
// 			questionEditor.value.setHTML(description.value);
// 		});
// 	}
// 	else {
// 		questionEditor.value.setHTML("");
// 	}
// }
//
const onUpdateContent = (content) => {
	description.value = questionEditor.value.getHTML();
}

const onUpdateContentPast = (content) => {
	description_past.value = questionEditorPast.value.getHTML();
}

const resetVariables = () => {
    description.value = "";
	description_past.value = "";
	sub_text.value = null;
	sub_text_past.value = null;
    questionEditor.value.setHTML("");
	questionEditorPast.value.setHTML("");
    question_type.value = null;
    num_choices.value = 2;
	mode.value = null;
    min_value.value = null;
    max_value.value = null;
    exclude_values.value = false;
	icon_class.value = null;
	units.value = null;
    choices.value = [];
    question_condition.value = false;
    selectedRelatedQuestions.value = [];
    skippable.value = false;
    status.value = false;
	anonymous.value = false;
    variable_name.value = null;
    custom_variable.value = null;
}

const removeChoice = (data) => {
    choices.value = choices.value.filter(choice => choice.uuid !== data.uuid);
}

const updateChoiceData = (data) => {
    choices.value = choices.value.map((choice) => {
        if (choice.uuid === data.uuid) {
            choice[data.field] = data.value;
        }
        return { ...choice };
    });
}

const removeRelated = (data) => {
    if (data.uuid) {
        selectedRelatedQuestions.value = selectedRelatedQuestions.value.filter(selectedQs => selectedQs.uuid !== data.uuid);
    }
}

const selectRelated = (data) => {
    if (data.selectedQs.value) {
        data.selectedQs.value['correct_choices'] = [];
        selectedRelatedQuestions.value = selectedRelatedQuestions.value.filter(selectedQs => selectedQs.id !== data.selectedQs.value.id);

        selectedRelatedQuestions.value = selectedRelatedQuestions.value.map((selectedQs) => {
            if (selectedQs.uuid === data.uuid) {
	            return {...selectedQs, ...data.selectedQs.value};
            }
            return { ...selectedQs };
        });
    }
}

const relatedChoices = (data) => {
    if (data.selectedQs.value) {
        selectedRelatedQuestions.value = selectedRelatedQuestions.value.map((selectedQs) => {
            if (selectedQs.id === data.selectedQs.value.id) {
                selectedQs['correct_choices'] = data.correct_choices;
            }
            return { ...selectedQs };
        });
    }
}

const get_related_qs_selected_choices = async (question_id, uuid) => {
    let url = "/admin/questions/get_correct_choices/" + props.id + "/" + question_id;
    try {
        let response = await apiClient.get(url, {});
        if (response.status === 200) {
            let correct_choices = response.data.choices;
            selectedRelatedQuestions.value = selectedRelatedQuestions.value.map((selectedQs) => {
                if (selectedQs.uuid === uuid) {
                    selectedQs['correct_choices'] = correct_choices;
                }
                return { ...selectedQs };
            });
        }
    }
    catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
    }
}

const fetchRelatedQuestions = async () => {
    let url = "/admin/questions/related_question/";
    try {
        let response = await apiClient.get(url, {});
        if (response.status === 200) {
            relatedQuestions.value = response.data.related_question;
        }
        else {
            relatedQuestions.value = [];
        }
    }
    catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
        relatedQuestions.value = [];
    }
}

const fetchQuestion = async () => {
    let url = "/admin/questions/fetch_question/" + props.id;
    try {
        let response = await apiClient.get(url, {});
        if (response.status === 200) {
            question.value = response.data.question;

            description.value = question.value.description;
            questionEditor.value.setHTML(question.value.description); // Setting Value in Quill Editor
	        // questionEditor.value.setHTML(description.value);

	        description_past.value = question.value.description_past;
	        questionEditorPast.value.setHTML(question.value.description_past); // Setting Value in Quill Editor
	        // questionEditorPast.value.setHTML(description_past.value);

	        sub_text.value = question.value.sub_text;
	        sub_text_past.value = question.value.sub_text_past;

            question_type.value = question.value.question_type;
            num_choices.value = question.value.num_choices;
			mode.value = question.value.mode;
            min_value.value = question.value.min_value;
            max_value.value = question.value.max_value;

            exclude_values.value = !!question.value.exclude_values;
			icon_class.value = question.value.icon_class;
			units.value = question.value.units;

            for (let i = 0; i < question.value.choices.length; i++) {
                choices.value.push({
                    uuid: uuidv4(),
                    text: question.value.choices[i].text,
                    value: question.value.choices[i].value,
                    order: question.value.choices[i].order_num,
                    type: question.value.choices[i].type,
                });
            }
            question_condition.value = question.value.question_condition === 'ALL';
            for (let i = 0; i < question.value.parent_questions.length; i++) {
                let uuid = uuidv4();
                selectedRelatedQuestions.value.push({
                    uuid: uuid, ...question.value.parent_questions[i]
                });
                await get_related_qs_selected_choices(question.value.parent_questions[i].id, uuid);
            }
            skippable.value = !!question.value.skippable;
            status.value = !!question.value.status;
			anonymous.value = !!question.value.anonymous;
            let variable_found = variable_name_options.some(variable => variable.value === question.value.variable_name);
            if (variable_found) {
                variable_name.value = question.value.variable_name;
                custom_variable.value = null;
            }
            else {
                variable_name.value = null;
                custom_variable.value = question.value.variable_name;
            }
        }
        else {
            question.value = null;
            resetVariables();
        }
    }
    catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
        question.value = null;
    }
}

const checkQuestionData = () => {
    let data = {};
    // description.value = questionEditor.value?.getHTML();
	// description_past.value = questionEditorPast.value?.getHTML();

    // Question Type and Question Description Check
    if (question_type.value == null || description.value == null || description.value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === "") {
		toast.displayToast('Please select question type and enter question description.', 'danger', 8000);
        return false;
    }
	if (description_past.value == null || description_past.value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === "") {
		toast.displayToast("Please enter question description for (Medication I've Taken).", 'danger', 8000);
		return false;
	}

	if ((countStarredPlaceholders(description.value) + countStarredPlaceholders(sub_text.value)) > 1) {
		toast.displayToast('You can use only one starred placeholder in description and sub text combined (Current Medication).', 'danger', 8000);
		return false;
	}

	if ((countStarredPlaceholders(description_past.value) + countStarredPlaceholders(sub_text_past.value)) > 1) {
		toast.displayToast("You can use only one starred placeholder in description and sub text combined (Medication I've Take).", "danger", 8000);
		return false;
	}

    // Handling Related Questions
    let related = [];
    let correct_choices = [];
    selectedRelatedQuestions.value.forEach(relatedQ => {
        if (relatedQ.correct_choices && relatedQ.correct_choices.length) {
            related.push(relatedQ.id);
            correct_choices.push(relatedQ.correct_choices.map(choice => choice.id));
        }
        else {
            related.push(relatedQ.id);
            correct_choices.push(null);
        }
    });
    data["related"] = related;
    data["correct_choices"] = correct_choices;

    // Handling Choices for the Questions
    let choices_array = [];
    let choices_value_array = [];
    let choices_order_array = [];
    choices.value.forEach(choice => {
        if (choice.text && choice.text.trim()) {
            choices_array.push(choice.text.trim());
            let temp_val = choice.value;
            let temp_order = choice.order;
            if (isNaN(Number(temp_order)) || Number(temp_order) <= 0) {
                temp_order = 1;
            }
            else {
                temp_order = Number(temp_order);
            }
            choices_value_array.push(temp_val);
            choices_order_array.push(temp_order);
        }
    });
    data["choices"] = choices_array;
    data["values"] = choices_value_array;
    data["order"] = choices_order_array;

	// let unitsArray = [];
	if(question_type.value !== 'SliderInput') {
		units.value = null;
	}
	// else{
	// 	if (units.value && units.value.trim()) {
	// 		unitsArray = units.value.split(',').map(unit => unit.trim());
	// 	}
	// }

	if(question_type.value !== 'DropdownSelect' && question_type.value !== 'BoxChoices') {
		icon_class.value = null;
	}

	if(question_type.value !== 'SliderInput' && question_type.value !== 'LikertScale') {
		min_value.value = null;
		max_value.value = null;
	}

	if(variable_name.value === 'medication' || variable_name.value === 'condition_therapy'){
		status.value = true;
		anonymous.value = true;
	}

    data = {
        ...data,
        ...{
            skippable: skippable.value ? 1 : 0,
            status: status.value ? 1 : 0,
	        anonymous: anonymous.value ? 1 : 0,
            question_condition: question_condition.value ? 'ALL' : 'ANY',
            num_choices: num_choices.value,
	        mode: mode.value,
            question_type: question_type.value,
            min_value: min_value.value,
            max_value: max_value.value,
            description: description.value,
	        description_past: description_past.value,
            sub_text: sub_text.value,
	        sub_text_past: sub_text_past.value,
	        exclude_values: exclude_values.value ? 1 : 0,
            icon_class: icon_class.value ? icon_class.value : null,
            units: units.value ? units.value : null,
            variable_name: variable_name.value ? variable_name.value : custom_variable.value,
        }
    };

    return data;
}

const saveQuestion = async () => {
    helper.loaderOn(questionEditorModal.value, false, false);

    let url = "/admin/questions/add_question";
    if (props.id !== null) {
        url = "/admin/questions/edit_question/" + props.id;
    }

    let data = checkQuestionData();
    if (data) {
		data['is_model_question'] = isModelQuestion.value ? 1 : 0;
        try {
            let response = await apiClient.post(url, data);
            if (response.status === 200) {
                if (editorMode.value === 'add') {
                    resetVariables();
                    emits('questionAdded');
                }
                else {
                    emits('questionEdited');
                }
            }
            helper.loaderOff(questionEditorModal.value);
        }
        catch (error) {
            let errorObj = await useHttpErrorManager().handleError(error, false);
            helper.loaderOff(questionEditorModal.value);
        }
    }
    else {
        helper.loaderOff(questionEditorModal.value);
    }
}

const countStarredPlaceholders = (text) => {
	if (!text) return 0;

	const regex = /\[\*\s*([a-zA-Z0-9_ ]+)\s*\*\]/g;
	let match;
	let count = 0;

	while ((match = regex.exec(text)) !== null) {
		const variable = match[1].trim();
		if (validVariables.includes(variable)) {
			count++;
		}
	}

	return count;
};

const close = async () => {
    if (modal.value) {
        modal.value.hide();
    }
}

watch(question_type, async (val) => {
	if(val === 'DropdownSelect') {
		mode.value = 'singular';
	}
	else if (val === 'LikertScale') {
		mode.value = 'rating';
	}
});

onMounted(async () => {
	await nextTick(async () => {
		const modalEl = document.getElementById('questionModal');
		modal.value = Modal.getOrCreateInstance(modalEl);
		modal.value.show();

		modalEl.addEventListener('hide.bs.modal', function(event) {
			modalEl.querySelector('.modal-dialog').classList.add('closing');
			setTimeout(() => {
				modalEl.querySelector('.modal-dialog').classList.remove('closing');
			}, 500)
			emits('closeModal');
		});

		while (!questionEditor.value) {
			await new Promise(resolve => setTimeout(resolve, 100));
		}
		while (!questionEditorPast.value) {
			await new Promise(resolve => setTimeout(resolve, 100));
		}

		await (async() => {
			helper.loaderOn(questionEditorModal.value, false, false);
			if(props.id) {
				await fetchQuestion();
			}
			await fetchRelatedQuestions();
			helper.loaderOff(questionEditorModal.value);
		})();
	});

});

defineExpose({
    close
});

</script>

<style lang="scss" scoped></style>